module.exports = __webpack_public_path__ + "media/src/images/top_img-afd3c78d8325354e48db7f9bc77af360.png";